/**
 * "32/100" under a text field once it nears its limit (from 80 % of `max`), red at the limit. The
 * field itself has maxLength={max}; an old value that is already longer is shown as e.g. "150/100".
 */
export default function CharCount({ value, max }) {
  const length = String(value ?? "").length;
  if (length < max * 0.8) return null;
  return (
    <div
      data-testid="char-count"
      aria-live="polite"
      className={`mt-1 text-right text-xs ${length >= max ? "text-red-600 dark:text-red-400" : "text-gray-500 dark:text-gray-400"}`}
    >
      {length}/{max}
    </div>
  );
}
